import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import SettingsSection from './SettingsSection';

const UserIdContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const UserIdLabel = styled.span`
  font-size: 14px;
  color: #4a6fa1;
  
  strong {
    font-weight: 600;
  }
`;

const UserId = styled.span`
  background: rgba(74, 111, 161, 0.1);
  padding: 4px 8px;
  border-radius: 6px;
  font-family: monospace;
  font-size: 14px;
  color: #4a6fa1;
`;

const UserInfoSection = ({ userId }) => {
  const { t } = useTranslation();
  
  return (
    <SettingsSection>
      <UserIdContainer>
        <UserIdLabel><strong>{t('your_user_id')}</strong>:</UserIdLabel>
        <UserId>{userId}</UserId>
      </UserIdContainer>
    </SettingsSection>
  );
};

export default UserInfoSection;